import Mixpanel from "utils/mixpanel";
import { PATHS } from "constants/pathConstants";
import CancerNavigationHeartIcon from "assets/images/CancerNavigationHeart.svg";
import DashboardCtaCard from ".";
import Translate from "translate/Translate";

const CancerNavigationDashboardCtaCard = () => {
  return (
    <DashboardCtaCard
      icon={CancerNavigationHeartIcon}
      header={<Translate text={"Cancer Navigation"} />}
      subheader={
        <Translate
          text={"We have a dedicated team to help support your journey."}
        />
      }
      link={{
        onClick: () => {
          Mixpanel.track(`Dashboard Card CTA Clicked - Cancer Navigation`);
        },
        overrideClick: false,
        target: "blank",
        text: "View",
        url: PATHS.CANCER_GUARDIAN_RESOURCE
      }}
    />
  );
};

export default CancerNavigationDashboardCtaCard;
